exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2M8TVBbslPgWkh2hGNLO1M,._302xqwk9__qzbNjPveq62u{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] ._2M8TVBbslPgWkh2hGNLO1M{text-shadow:0 0 \"[theme:blackTranslucent40, default:rgba(0, 0, 0, .4)]\"}html[dir] ._3pU5O3vlMDNrqZI28FuKu2{background:\"[theme:neutralLighter, default:#f4f4f4]\";border-radius:2px}", ""]);
// Exports
exports.locals = {
	"categoryIcon": "_2M8TVBbslPgWkh2hGNLO1M",
	"iconCommon": "_302xqwk9__qzbNjPveq62u",
	"colorPickerContainerDiscoverable": "_3pU5O3vlMDNrqZI28FuKu2"
};